export default "__VITE_ASSET__bN4hhq6w__"